import { all, fork } from "redux-saga/effects";
import { UserManagementSaga } from "./components/user-management/user-management-saga";
import { companyInformationSaga } from "./components/company-information/company-information-saga";
import { invoiceHistorySaga } from "./components/invoice-history/invoice-history-saga";

export function* informationPageSaga() {
  yield all([fork(UserManagementSaga), fork(companyInformationSaga), fork(invoiceHistorySaga)]);
}
